export const AWS_REGION = 'us-east-1'
export const AWS_IOT_ENDPOINT = 'a2z5b1fl7oeyp5-ats.iot.us-east-1.amazonaws.com'
export const AWS_COGNITO_IDENTITY_POOL_ID = 'us-east-1:f303f842-d0b0-4344-b4a5-400b773b9eef'
export const AWS_IOT_ALLTHINGS_TOPIC = 'allthings/status'
